var exports = {
  "N": "viewerDidAuthor__SYEyD4",
};

module.exports = exports;
